export default theme => ({
  link: {
    color: `${theme.palette.primary.main} !important`,
  },
});
